$(function () {
    $('.expert-video-block').each(function () {
        resizeIframe(this);
        $(window).on('resize', () => resizeIframe(this));
    });

    function resizeIframe (context) {
        const iframe = $(context).find('iframe');

        if (iframe[0]) {
            const height = iframe.attr('height');
            const width = iframe.attr('width');
            const aspectRatio = width / height;
            const innerWidth = iframe.parent().innerWidth();
            iframe.css('width', Math.round(innerWidth));
            iframe.css('height', Math.round(innerWidth / aspectRatio));
        }
    }
});
